import { createSlice } from '@reduxjs/toolkit';

import type * as GlobalNavigationTypes from './types';

const name = 'globalNavigation';

const initialState: GlobalNavigationTypes.GlobalNavigationState = {
    showCreateWishlistModal: false,
};

export const globalNavigationSlice = createSlice({
    name,
    initialState,
    reducers: {
        showCreateWishlistModal(state, { payload }: GlobalNavigationTypes.GlobalActivityActionTypes) {
            return { ...state, showCreateWishlistModal: payload };
        },
    },
});
